import {
  ClockIcon,
  Mtds,
  PencilSimpleIcon,
  PlayIcon,
  StopIcon,
  WarningIcon,
  XIcon
} from 'prove-common'
import type { PlanStatusEnum } from '../../types/types'

const STATUS = {
  draft: {
    icon: <PencilSimpleIcon weight='fill' />,
    text: 'Utkast',
    color: 'neutral'
  },
  active: {
    icon: <PlayIcon weight='fill' />,
    text: 'Aktiv',
    color: 'success'
  },
  deactivated: {
    icon: <StopIcon weight='fill' />,
    text: 'Deaktivert',
    color: 'neutral'
  },
  overdue: {
    icon: <ClockIcon weight='fill' />,
    text: 'Forfalt',
    color: 'danger'
  },
  terminated: {
    icon: <XIcon weight='bold' />,
    text: 'Avsluttet',
    color: 'neutral'
  }
} as const

export const PlanStatusTag = ({ status }: { status: PlanStatusEnum }) => (
  <Mtds.Tag data-color={STATUS[status]?.color || 'neutral'} data-icon='none'>
    {STATUS[status]?.icon || <WarningIcon weight='bold' />}
    {STATUS[status]?.text || 'Ukjent status'}
  </Mtds.Tag>
)
